/* eslint-disable camelcase */
import React from 'react'
import { Link } from 'react-router-dom'

export const UserEventCard = ({ type, reservation, evento = {} }) => {
  return (
    <div className="card border-0 shadow-sm overflow-hidden mb-4" style={{ height: '240px' }}>
        <div className="row g-0">
            <img src= "https://res.cloudinary.com/atemporal/image/upload/v1664227433/dev_setups/zdsezpf1kpus5oxtrmdf.png"
              className="col-sm-4 bg-repeat-0 bg-position-center bg-size-cover h-100"
              alt='Codigo QR de reservacion'
            />
            <div className="col-sm-8">
              <div className="card-body">
              <div className="fs-sm text-muted mb-1">Fecha: {evento.fecha_evento}</div>
                <h2 className="h4 pb-1 mb-2">
                {evento.nombre_evento}
                </h2>
                <h2 className="h4 pb-1 mb-2">
                  Cantidad: 12 boletos
                </h2>
              </div>
            </div>
          </div>
        </div>
  )
}
